<template>
    <div>
        <client-only>
            <div class="rounded-lg max-w-max mx-auto my-8 flex flex-wrap justify-center gap-4">
                <button type="button" @click="changeTab(0)"
                    class="p-1 px-16 border border-gray-400 bg-gray-100 rounded-lg pw-text-black text-gray-900 hover:bg-white transition"
                    :class="{ 'border-primary-500 !text-primary-500 font-medium bg-white': tabIndex === 0 }"> RAG
                    Templates</button>
                <button type="button" @click="changeTab(1)"
                    class="p-1 px-16 border border-gray-400 bg-gray-100 rounded-lg pw-text-black text-gray-900 hover:bg-white transition"
                    :class="{ 'border-primary-500 !text-primary-500 font-medium bg-white': tabIndex === 1 }">ETL
                    Templates</button>
            </div>
        </client-only>
        <div v-show="tabIndex === 0">
            <a :href="`#ai-pipelines`" class="mt-5 divider hover:underline hover:decoration-dotted" id="ai-pipelines">
                <span class="font-bold text-xl capitalize">RAG Templates</span>
            </a>
            <div class="news__container grid gap-5 justify-around mt-5" v-if="AIPipelinesArticles.length > 0">
                <template v-for="(article, i) in AIPipelinesArticles">
                    <template v-if="!article?.hide">
                        <TemplateTile :article="article" :index="i" />
                    </template>

                </template>
            </div>
        </div>
        <span v-if="currentTerm">Filtered by <span class="font-bold">{{ currentTerm }}</span></span>
        <div v-show="tabIndex === 1">
            <div class="my-4">
                <hr class="mb-4" />
                <span class="font-semibold">Filter App Templates</span>
            </div>

            <div class="mb-10 w-full flex items-center flex-wrap gap-4 lg:gap-12">
                <div v-for="filter in filters" class="flex gap-4 flex-wrap">
                    <div v-for="tags in filter">
                        <label class="border p-2 border-primary-200 rounded-lg cursor-pointer flex gap-2 items-center"
                            :title="`filter by ${tags.label}`" :class="tags?.class">
                            <input type="checkbox" v-model="selected[tags.id]" :value="tags.id"
                                class="h-4 w-4 dark:checked:bg-current dark:checked:border-transparent dark:indeterminate:bg-current dark:indeterminate:border-transparent disabled:opacity-50 disabled:cursor-not-allowed focus:ring-0 focus:ring-transparent focus:ring-offset-transparent form-checkbox rounded bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-gray-900 text-primary-500 dark:text-primary-400 cursor-pointer">
                            <span class="text-sm font-medium flex gap-1 items-center">
                                <Icon :name="tags.icon" class="text-lg" v-if="tags.icon" />
                                {{ tags.label }}
                            </span>
                        </label>
                        <!-- <UCheckbox :label="tags.label"
                        :ui="{ wrapper: 'border border-primary-200 rounded-lg cursor-pointer', label: 'cursor-pointer  m-2', base: 'cursor-pointer p-2' }" /> -->
                    </div>
                </div>
            </div>
            <div>
                <template v-for="(tagArticles, tagKey) in articlesToShow" :key="tagKey">
                    <a :href="`#${tagKey.replaceAll(/ /g, '-')}`"
                        class="mt-5 divider hover:underline hover:decoration-dotted" :id="tagKey.replaceAll(/ /g, '-')">
                        <span class="font-bold text-xl capitalize">{{ TUTORIAL_TAGS.get(tagKey) || tagKey }}</span>
                    </a>
                    <div class="news__container grid gap-5 justify-around mt-5">
                        <template v-for="(article, i) in tagArticles">
                            <template v-if="!article?.hide">
                                <TemplateTile :article="article" :index="i" />
                            </template>

                        </template>
                    </div>
                </template>
            </div>
            <template v-if="Object.keys(articlesToShow).length === 0">
                <div class="w-max p-4 mx-auto text-lg">
                    We found nothing, subscribe to our newsletter so you don't miss anything
                </div>
            </template>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    path: String
})

const activeContent = ref(null)
const expandContent = (index) => {
    activeContent.value = activeContent.value === index ? null : index
}
// const AIPipelinesArticles = []

const tabs = [{
    href: "ai-pipelines",
    slot: "ai-pipelines"
}, {
    href: "live-data-framework",
    slot: "streaming"
}]

const indexMap = {
    "ai-pipelines": 0,
    "live-data-framework": 1
}
const route = useRoute()
const router = useRouter()
console.log("QUERY:", route.query.tab)

const tabIndex = ref(indexMap[route.query.tab] ?? 0)

watch(() => route.query.tab, (newTab) => {
    if (newTab && indexMap[newTab] !== undefined) {
        tabIndex.value = indexMap[newTab]
    }
})

const changeTab = (index) => {
    // console.log(route.query.tab, router, index)
    tabIndex.value = index
    router.replace({
        query: { tab: tabs[index].href }
    })
}

/*
*  Custom tutorial tags:
*  Used only for correct display (eg. machine-learning is Machine Learning)
*/
const TUTORIAL_TAGS = new Map([
    ['machine-learning', 'Machine Learning'],
    ['data-pipeline', 'Live Data pipeline'],
    ['sql', 'SQL'],
    ['ai-pipelines', 'AI Pipelines']
])

const filters = [
    [
        { id: "Docker", label: "Docker", icon: "mdi:docker", class: "border-secondary-500" },
        { id: "notebook", label: "Notebook", icon: "cib:jupyter", class: "border-secondary-500" }
    ],
    [
        { id: "data-pipeline", label: "Live Data Pipeline" },
        { id: "machine-learning", label: "Machine Learning" },
        { id: "time series", label: "Time Series" }
    ]
]
const selected = ref({})

const AllArticles = ref(await queryContent(props.path).where({ 'article': { '$exists': true }, 'author': { '$exists': true } }).sort({ 'priority': -1, 'article.date': -1 }).without(['body']).find())
const AIPipelinesArticles = ref(await queryContent(props.path).where({ 'article': { '$exists': true }, 'author': { '$exists': true }, 'article.tags': { $in: ['ai-pipelines'] } }).sort({ 'priority': -1, 'article.date': -1 }).without(['body']).find())
const articles = ref(
    AllArticles.value.filter(article =>
        !AIPipelinesArticles.value.some(aiArticle => aiArticle._id === article._id)
    )
);

const query = route.query.q
const currentTerm = ref("")

let articlesToShow = ref(groupArticles(articles.value))

const searchArticles = (ev) => {
    const activeTags = Object.keys(selected.value).filter(tag => selected.value[tag])

    // Split the active tags into two categories: technology and topic
    const activeTechnologyTags = activeTags.filter(tag => ["docker", "notebook"].includes(tag.toLowerCase()))
    const activeTopicTags = activeTags.filter(tag => ["data-pipeline", "machine-learning", "time series"].includes(tag.toLowerCase()))

    // Filter the articles based on the tag categories
    const filteredArticles = articles.value.filter((article) => {
        // Extract and normalize keywords and tags from the article
        let keywords = article?.keywords?.join(" ")?.toLowerCase() || ""
        let tags = article?.article?.tags?.join(" ")?.toLowerCase() || ""


        const matchesTechnology = activeTechnologyTags.length === 0 || activeTechnologyTags.some(tag => keywords.includes(tag.toLowerCase()))
        const matchesTopic = activeTopicTags.length === 0 || activeTopicTags.some(tag => tags.includes(tag.toLowerCase()))

        // An article is included if it matches both technology and topic criteria
        const matchesTags = matchesTechnology && matchesTopic

        return matchesTags
    })

    articlesToShow.value = groupArticles(filteredArticles)
}


if (query) {
    currentTerm.value = query
    searchArticles({ target: { value: query } })
}
watch(selected, searchArticles, { deep: true })

function groupArticles (articles) {
    const groupedArticles = {}
    articles.forEach((article) => {
        if (article.article.tags.length > 0) {
            if (article.article.tags[1] === 'ai-pipelines') {
                // AIPipelinesArticles.push(article)
            }
            let selectedTag = null
            const firstTag = article.article.tags[0].toLowerCase()
            if (firstTag === 'tutorial' || firstTag === 'showcase') {
                if (article.article.tags.length > 1) {
                    selectedTag = article.article.tags[1].toLowerCase()
                }
            } else {
                selectedTag = firstTag
            }
            if (selectedTag && selectedTag !== 'tutorial' && selectedTag !== 'showcase') {
                if (!groupedArticles[selectedTag]) {
                    groupedArticles[selectedTag] = []
                }
                if (article?.popular) {
                    article.priority = article.priority || 10
                }
                groupedArticles[selectedTag].push(article)
                groupedArticles[selectedTag].sort((a, b) => {
                    let ap = a.priority || 0
                    let ab = b.priority || 0
                    return ab - ap
                })
            }
        }
    })

    return getTemplatesOrder(groupedArticles)
}

</script>

<style lang="scss" scoped>
.divider {
    position: relative;
    display: block;
    width: 100%;

    &:not(:first-of-type) {
        margin-top: 3rem;
    }

    &:after {
        content: "";
        position: absolute;
        display: block;
        width: 100%;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        background-color: #c4c4c4;
        height: 1px;
        z-index: 1;
    }

    span {
        position: relative;
        z-index: 2;
        background-color: #fff;
        padding-right: 3rem;
    }
}

.news__container {
    grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr))
}
</style>
